/** URL-safe slug for a blog category ("Costs & Pricing" -> "costs-and-pricing").
 *  Must match the server's categorySlug (server/src/routes/blog.ts). */
export function categorySlug(cat: string): string {
  return cat.toLowerCase().replace(/&/g, 'and').replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '')
}
